import * as React from "react"

const defaultState = {
  docs: {},
  action: false,
  searchKeyword: "" 
}

const SearchContext = React.createContext(defaultState);

export const SearchContextProvider = ({ children }) => {
  const [docs, setDocs] = React.useState(defaultState.docs)
  const [action, setAction] = React.useState(defaultState.action)
  const [searchKeyword, setSearchKeyword] = React.useState(defaultState.searchKeyword) 


  const contextValues = {
    docsValue: docs,
    setdocsValue: setDocs,
    actionValue: action,
    setactionValue: setAction,
    searchKeyword,            
    setSearchKeyword          
  }
  //{children}は、このProviderコンポーネントがラップする他のReactコンポーネント（ツリー）を表す
  // SearchContextProviderでラップされたすべてのコンポーネントが、提供されるcontextValuesにアクセスできる
  return <SearchContext.Provider value={contextValues}>{children}</SearchContext.Provider>
}

export const useSearchContext = () => {
  const context = React.useContext(SearchContext)
  if (context === undefined || context === null) {
    throw new Error(`useSearchContext must be called within SearchContextProvider`)
  }
  return context
}